export const generateUniqueId = () => {
  const timestamp = new Date().getTime().toString()
  const randomSuffix = Math.random().toString(36).substring(7)
  // toString(36) convierte un número en una cadena utilizando la base 36.
  // substring(7) devuelve una parte de la cadena a partir del séptimo carácter.

  return `${timestamp}_${randomSuffix}`
}



// WEBPACK FOOTER //
// ./src/utils/index.js